
const StakingSection = () => {
  const stakingTiers = [
    {
      name: "🥉 Bro Badge",
      minStake: "1,000 $TOP1",
      perks: "Basic Access",
      features: ["Token-gated bot access", "Community coordination", "Monthly MNFT eligibility"]
    },
    {
      name: "🥈 Meme Warrior", 
      minStake: "10,000 $TOP1",
      perks: "Enhanced Perks",
      features: ["Priority meme deployment", "Exclusive coordination channels", "Weekly collectible airdrops", "Community proposal participation"]
    },
    {
      name: "🥇 Culture King",
      minStake: "100,000 $TOP1", 
      perks: "Maximum Vibes",
      features: ["Maximum coordination access", "VIP cultural events", "Daily artifact eligibility", "Priority community participation", "Exclusive meme ops"]
    }
  ];

  return (
    <section id="staking" className="py-16 bg-secondary">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-4">
            🎯 Community Perks
          </h2>
          <p className="text-lg text-muted-foreground max-w-4xl mx-auto mb-4">
            Stake your $TOP1 to unlock perks like MNFT airdrops, participation badges, bot access, and more. Staking is not financial — it's how you show up for the community and support Bromentum's culture stack.
          </p>
          <div className="bg-red-500/10 border border-red-500/20 rounded-lg p-3 max-w-3xl mx-auto">
            <p className="text-sm text-muted-foreground">
              <strong>Disclaimer:</strong> Staking does not generate financial returns or constitute investment activity. Participation is for utility, experimentation, and culture.
            </p>
          </div>
        </div>
        
        <div className="grid md:grid-cols-3 gap-8">
          {stakingTiers.map((tier, index) => (
            <div key={index} className="bg-background rounded-lg p-6 border border-border text-center">
              <div className="text-center mb-6">
                <h3 className="text-xl font-bold text-foreground mb-2">{tier.name}</h3>
                <div className="text-2xl font-bold text-primary mb-1">{tier.perks}</div>
                <div className="text-sm text-muted-foreground">Minimum: {tier.minStake}</div>
              </div>
              <ul className="space-y-2 mb-6">
                {tier.features.map((feature, idx) => (
                  <li key={idx} className="text-muted-foreground">✓ {feature}</li>
                ))}
              </ul>
              <button 
                className="w-full bg-primary text-primary-foreground py-2 px-4 rounded-lg hover:bg-primary/90 transition-colors"
                onClick={() => window.open('https://t.me/bromentumcommunity', '_blank')}
              >
                Join Community
              </button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StakingSection;
